export const CHANGE_LANG = "CHANGE_LANG";
